<style scoped>
    @import url("../../../styles/smartControl/exibFases.scss");
</style>

<template>
    <div class="box_exibFases">

        <div class="macro_el">
            <div class="tit ml-2">Todas as fases</div>

            <div class="painelSearch">

                <div class="horizontCard mt-1 mb-1" v-for="(phase,i) in local_phases" :key="i"
                @mouseover="phase.bg = '#F39C12'"
                @mouseleave="phase.bg = ''"
                :style="{'background':phase.bg}"
                @click="callSelected(i)"
                >

                    <!-- lado esquerdo-->
                    <div class="lado_a">
                        <v-icon class="ml-1" color="#395872" size="32">mdi-receipt-text-edit-outline</v-icon>
                        <v-chip class="ml-1" color="white">{{ phase.phase_name }}</v-chip>
                    </div>

                    <!-- lado direito -->
                    <div class="lado_b">

                        <v-chip :style="{'font-size':'0.8rem'}" color="white">{{ 'Início ' + phase.dtStrHR_init }}</v-chip>
                        <v-chip :style="{'font-size':'0.8rem'}" color="white" class="ml-1 mr-4">{{ 'Fim ' + phase.dtStrHR_end }}</v-chip>

                        <!-- FASE desabilitada -->
                        <v-icon v-if="phase.status == 'off'" 
                        size="32" 
                        color="gray"
                        >
                            mdi-circle
                        </v-icon>

                        <!-- FASE ativa e aguardando -->
                        <v-icon v-else-if="phase.status == 'on' && phase.active == false" 
                        size="32" 
                        color="yellow"
                        >
                            mdi-circle
                        </v-icon>

                        <!-- FASE ativa e em operação -->
                        <v-icon v-else-if="phase.status == 'on' && phase.active == true" 
                        size="32" 
                        color="green"
                        >
                            mdi-circle
                        </v-icon>

                        <!-- estado não previsto -->
                        <v-icon v-else
                        size="32" 
                        color="red"
                        >
                            mdi-circle
                        </v-icon>

                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>

//import convFromUtc from '../auxSC/timeConv.js'
import { convFromUtc } from "../auxSC/timeConv.js";

export default {

    props:['agent_unit'],

    data() {
        return {

            //
            local_phases:[],
        }
    },

    methods:{

        callSelected(index) {
            this.$emit('idPhaseSelected', index)
        },

        prepareListToExib(li) {

            const tzName = this.$store.state.fusoHorarioSC; // esperado --> "Europe/Lisbon"
            let c=0;
            while (c < li.length) {

                const init = convFromUtc(li[c]['utc_phase_init'], tzName);
                li[c]['dtStrHR_init'] = `${init.dataStr}-${init.hhmm}`; // criando nova key no dict local

                const end = convFromUtc(li[c]["utc_phase_end"], tzName);
                li[c]['dtStrHR_end'] = `${end.dataStr}-${end.hhmm}`; // criando nova key no dict local

                li[c]['bg'] = ''; // criando nova key no dict local (background color)

                c++
            }

            this.local_phases = li
        },
    },

    created() {
        //window.scrollTo(0,0)
        const phasesLocal = structuredClone(this.agent_unit["phases"]); // depth copy
        this.prepareListToExib(phasesLocal) // rcv via props
    }
}
</script>